import { QRCodeSVG } from 'qrcode.react';
import { CARD_W, CARD_H } from './cardSize';

export default function ClassicGold({ data, style }) {
  const { groomName, brideName, date, time, venue, address, message: msg, qrValue } = data || {};

  return (
    <div
      className="inv-card"
      style={{
        width: CARD_W, height: CARD_H,
        background: 'linear-gradient(145deg, #FFF8E7, #FFFDF5)',
        border: '3px solid #C5A14E',
        borderRadius: 12,
        padding: '8mm 9mm',
        fontFamily: "'Georgia', 'Times New Roman', serif",
        color: '#5A4520',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {/* Corner ornaments */}
      <div style={{ position: 'absolute', top: 5, left: 8, fontSize: 20, color: '#C5A14E', opacity: 0.6 }}>❧</div>
      <div style={{ position: 'absolute', top: 5, right: 8, fontSize: 20, color: '#C5A14E', opacity: 0.6, transform: 'scaleX(-1)' }}>❧</div>
      <div style={{ position: 'absolute', bottom: 5, left: 8, fontSize: 20, color: '#C5A14E', opacity: 0.6, transform: 'scaleY(-1)' }}>❧</div>
      <div style={{ position: 'absolute', bottom: 5, right: 8, fontSize: 20, color: '#C5A14E', opacity: 0.6, transform: 'scale(-1)' }}>❧</div>

      {/* Inner border */}
      <div style={{
        position: 'absolute', inset: '4mm',
        border: '1px solid #D4B96A', borderRadius: 7, pointerEvents: 'none',
      }} />

      <div style={{ fontSize: 9, letterSpacing: 3, textTransform: 'uppercase', color: '#B8960F', marginBottom: 6 }}>
        Taklif etamiz
      </div>

      <div style={{ fontSize: 21, fontWeight: 700, color: '#8B6914', lineHeight: 1.25, textAlign: 'center' }}>
        {groomName || 'Kuyov'} <span style={{ fontSize: 15, color: '#C5A14E', margin: '0 6px' }}>&</span> {brideName || "Kelin"}
      </div>

      <div style={{ width: 64, height: 1.5, background: 'linear-gradient(90deg, transparent, #C5A14E, transparent)', margin: '8px 0' }} />

      <div style={{ fontSize: 11, textAlign: 'center', lineHeight: 1.55, color: '#6B5530' }}>
        {date && <div style={{ fontWeight: 600 }}>{date}</div>}
        {time && <div>Soat: {time}</div>}
        {venue && <div style={{ fontWeight: 600, marginTop: 2 }}>{venue}</div>}
        {address && <div style={{ fontSize: 9.5, opacity: 0.8 }}>{address}</div>}
      </div>

      {msg && (
        <div style={{ fontSize: 8.5, fontStyle: 'italic', textAlign: 'center', color: '#8B7340', marginTop: 6, maxWidth: '78%' }}>
          {msg}
        </div>
      )}

      {qrValue && (
        <div style={{ position: 'absolute', bottom: '5mm', right: '5mm' }}>
          <QRCodeSVG value={qrValue} size={46} level="M" fgColor="#5A4520" bgColor="transparent" />
        </div>
      )}
    </div>
  );
}
